export default "__VITE_ASSET__oByd3gaY__"